import React from "react";
import "./Sponsi.css";
import "./animate.css";
import { baseUrl } from "../../constants";
const Sponsi = () => {
  const data = [
    { company: "Adda 24*7", src: `/image/SponsiLogos/adda247.jpg` },
    {
      company: "Coding Ninjas",
      src: `/image/SponsiLogos/coding ninjas1.png`,
    },
    { company: "Oyo", src: `/image/SponsiLogos/Oyo logo.png` },
    { company: "Paytm", src: `/image/SponsiLogos/Paytm.png` },
    { company: "", src: `/image/SponsiLogos/adda247.jpg` },
    { company: "", src: `/image/SponsiLogos/adda247.jpg` },
  ];
  const EventCard = ({ ldata, key }) => {
    return (
      <div
        key={key}
        className="sponsor-logo h-30 bg-white shadow-md rounded-md m-3.5 flex justify-center items-center flex-row text-center transform transition duration-500 hover:scale-110"
      >
        <div
          key={key}
          className="animate__animated animate__fadeInRight typo transform transition duration-500 hover:scale-110 m-10"
        >
          <img
            alt=""
            src={ldata.src}
            className="animate__animated animate__bounceIn ans object-cover cursor-pointer "
          />
        </div>
      </div>
    );
  };
  return (
    <div className="sponsi-container bg-gray-200 flex flex-col md:flex-row justify-center items-center flex-wrap">
      {data.map((ldata, i) => (
        <EventCard ldata={ldata} key={i} />
      ))}
    </div>
  );
};

export default Sponsi;
